import Vue from "vue";
import VueRouter from "vue-router";

import finbridgeRoutes from "@/router/routes/finbridge.js";
import externalRoutes from "@/router/routes/external.js";
import csCenterRoutes from "@/router/routes/cscenter.js";
import termsRoutes from "@/router/routes/terms.js";
import { FB_HOMEPAGE_URL, isSafeguardHost } from "@/assets/js/safeguardSite";

Vue.use(VueRouter);

let routes = [
  // DB 긴급점검시 주석처리
  {
    path: "/periodicInspection/:fdrmChkDayInfo",
    name: "PeriodicInspection",
    component: () => import(/* webpackChunkName: "periodicInspection" */ "@/pages/errors/PeriodicInspection.vue")
  },
  {
    path: "*",
    name: "PageNotFound",
    meta: { gtm: "404 페이지" },
    component: () => import(/* webpackChunkName: "pageNotFound" */ "@/pages/errors/PageNotFound.vue")
  }
  // DB 긴급점검시 주석해제
  // {
  //   path: "*",
  //   name: "periodicInspectionCheck",
  //   component: () => import(/* webpackChunkName: "periodicInspectionCheck" */ "@/pages/errors/PeriodicInspectionCheck.vue")
  // }
];
// DB 긴급점검시 주석처리
routes = routes.concat(finbridgeRoutes, externalRoutes, csCenterRoutes, termsRoutes);

// export default new Router({
//   mode: "history",
//   base: process.env.BASE_URL,
//   routes,
//   linkExactActiveClass: "exact-active",
//   linkActiveClass: "active",
//   scrollBehavior(to, from, savedPosition) {
//     return { x: 0, y: 0 };
//   }
// });

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // linkExactActiveClass: "exact-active",
  // linkActiveClass: "active",
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

// 세이프가드 홈페이지는 첫 화면만 서비스한다. 다른 주소는 핀브릿지 홈페이지의 같은 화면으로 보낸다
if (isSafeguardHost()) {
  router.beforeEach((to, from, next) => {
    if (to.name === "Home") {
      next();
      return;
    }
    window.location.replace(FB_HOMEPAGE_URL + to.fullPath);
    next(false);
  });
}

export default router;